<ion-app>
    <ion-split-pane contentId="main-content">
        <ion-menu  *ngIf="pageController.pagesAll.length" [ngClass]="{'menuExpand': menuExpand}" contentId="main-content" type="overlay">

            <ion-header>

                <ion-toolbar>
                    <ion-buttons slot="secondary">
                        <ion-button (click)="expandMenu()">
                            <ion-icon slot="icon-only" name="swap-horizontal"></ion-icon>
                        </ion-button>
                    </ion-buttons>

                    <ion-title *ngIf="menuExpand">{{'Menu' | translate}}</ion-title>

                </ion-toolbar>
            </ion-header>

            <ion-content  class="outer-content">

                <ion-list *ngIf="user.api._user.profile && user.api._user.profile.role === 'all'">
                    <ion-item button *ngFor="let p of pageController.pagesAll" (click)="openPage(p)">
                        <ion-icon slot="start" [name]="p.icon" [src]="p.iconSrc" ></ion-icon>
                        <ion-label>{{p.title}}</ion-label>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="user.api._user.profile &&  user.api._user.profile.role === 'alertOnly'">
                    <ion-item button *ngFor="let p of pageController.pagesAlertOnly" (click)="openPage(p)">
                        <ion-icon slot="start" [name]="p.icon" [src]="p.iconSrc" ></ion-icon>
                        <ion-label>{{p.title}}</ion-label>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="user.api._user.profile && user.api._user.profile.role === 'TechnicOnly'">
                    <ion-item button *ngFor="let p of pageController.pagesTechnicOnly" (click)="openPage(p)">
                        <ion-icon slot="start" [name]="p.icon" [src]="p.iconSrc" ></ion-icon>
                        <ion-label>{{p.title}}</ion-label>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="user.api._user.profile && user.api._user.profile.role === 'supportOnly'">
                    <ion-item button *ngFor="let p of pageController.pagesSupportOnly" (click)="openPage(p)">
                        <ion-icon slot="start" [name]="p.icon" [src]="p.iconSrc" ></ion-icon>
                        <ion-label>{{p.title}}</ion-label>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="user.api._user.profile && user.api._user.profile.role === 'relationOnly'">
                    <ion-item button *ngFor="let p of pageController.pagesRelationOnly" (click)="openPage(p)">
                        <ion-icon slot="start" [name]="p.icon" [src]="p.iconSrc" ></ion-icon>
                        <ion-label>{{p.title}}</ion-label>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="!user.api._user.token">
                    <ion-item button *ngFor="let p of pageController.pagesLogout" (click)="openPage(p)">
                        <ion-icon slot="start" [name]="p.icon" [src]="p.iconSrc" ></ion-icon>
                        <ion-label>{{p.title}}</ion-label>
                    </ion-item>
                </ion-list>

                <ion-list *ngIf="user.api._user.token">
                    <ion-list-header>
                        <ion-label>{{'Account' | translate}}</ion-label>
                    </ion-list-header>
                    <ion-item *ngIf="configName !== 'rksh'" button (click)="openPage({ title: 'Einstellungen', component: '/settings' })">
                        <ion-icon slot="start" name="settings-outline"></ion-icon>
                        <ion-label>{{'Settings' | translate}}</ion-label>
                    </ion-item>
                    <ion-item button (click)="logout()">
                        <ion-icon slot="start" name="log-out-outline"></ion-icon>
                        <ion-label>{{'Logout' | translate}}</ion-label>
                    </ion-item>
                </ion-list>

            </ion-content>
        </ion-menu>
        <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
</ion-app>
